import { PropsWithChildren } from 'react'
import Styles from './ButtonGroup.module.scss'

export const ButtonGroup = ({ children }: PropsWithChildren) => <div className={Styles.group}>{children}</div>
